module.exports = __webpack_public_path__ + "img/undraw_Content_creator_re_pt5b.6ffdb823.svg";